import System from "src/helper/system";
import CommonQuoteDetail from 'src/pages/QuoteDetail/CommonQuoteDetail';
import Helper from "../../src/support/Helper";
import Quote from "./quote";

let c = System.getParams();

class QuoteDetail {

    static QUOTE_SUBMITTED_LIST = Helper.getCartUrl() + '/api/quote/quote/submittedquotes';
    static QUOTE_SUBMITTED_DETAIL_SHORT_INFORMATION = Helper.getCartUrl() + '/api/quote/quote/headerdetails';
    static QUOTE_SUBMITTED_DETAIL_LIST_BY_STATUS = Helper.getCartUrl() + '/api/quote/quote/lineitems';
    static QUOTE_SUBMITTED_DETAIL_LIST_WITH_STATUS = Helper.getCartUrl() + '/api/quote/quote/search';
    static QUOTE_SUBMITTED_DETAIL_LIST_FOR_DASHBOARD = Helper.getCartUrl() + '/api/quote/quote/dashboard';

    static getQuoteDetailTabsListRouteURL(extra_c = {}) {
        c[CommonQuoteDetail.param_key_QuoteDetailTabList] = CommonQuoteDetail.chain.QuoteDetailTabsListing.param_value;
        return this.getURLBasedOnParamKey({
            ...c,
            ...extra_c
        });
    }

    static makeQuoteDetailTabsListRouteURL(param_value) {
        return this.getQuoteDetailTabsListRouteURL({
            ...c,
            [CommonQuoteDetail.param_key_QuoteDetailTabList]: param_value
        });
    }

    static getURLBasedOnParamKey(c) {
        return this.getQuoteDetailPageRouteURL(c);
    }

    static getQuoteDetailPageRouteURL(c = {}) {
        return Quote.getQuoteDetailRouteURL(c);
    }
}

export default QuoteDetail;